"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/TextArea/index.tsx
var TextArea_exports = {};
__export(TextArea_exports, {
  TextArea: () => TextArea
});
module.exports = __toCommonJS(TextArea_exports);
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var defaultClassName = [
  "v2-text-sm v2-w-full v2-p-3",
  "v2-border v2-border-neutral-300 v2-rounded-md",
  "focus:v2-border-turquoise-700 hover:v2-border-turquoise-700",
  "v2-outline-none v2-resize-none"
].join(" ");
function TextArea(_a) {
  var _b = _a, {
    label,
    value = "",
    placeholder,
    rows = 1,
    maxHeight,
    inputRef,
    className,
    style
  } = _b, props = __objRest(_b, [
    "label",
    "value",
    "placeholder",
    "rows",
    "maxHeight",
    "inputRef",
    "className",
    "style"
  ]);
  var _a2;
  const textAreaRef = inputRef != null ? inputRef : (0, import_react.useRef)(null);
  const [text, setText] = (0, import_react.useState)(value);
  const [textAreaHeight, setTextAreaHeight] = (0, import_react.useState)("auto");
  (0, import_react.useEffect)(() => setTextAreaHeight("auto"), [rows]);
  (0, import_react.useEffect)(() => {
    const scrollHeight = textAreaRef.current.scrollHeight;
    if (maxHeight && maxHeight <= scrollHeight) {
      setTextAreaHeight(`${maxHeight}px`);
      return;
    }
    const newHeight = !text && !placeholder ? "auto" : `${scrollHeight}px`;
    setTextAreaHeight(newHeight);
  }, [text, placeholder, maxHeight]);
  (0, import_react.useEffect)(() => setText(value), [value]);
  const onChangeHandler = (event) => {
    var _a3;
    setTextAreaHeight("auto");
    setText(event.target.value);
    (_a3 = props.onChange) == null ? void 0 : _a3.call(props, event);
  };
  const isScrollbarVisible = text && maxHeight && `${maxHeight}px` === textAreaHeight;
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, label, /* @__PURE__ */ import_react.default.createElement(
    "textarea",
    __spreadProps(__spreadValues({
      className: (0, import_classnames.default)(defaultClassName, className, {
        "v2-overflow-y-auto": isScrollbarVisible,
        "v2-scrollbar-thin scrollbar-track-neutral-200": isScrollbarVisible,
        "scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full": isScrollbarVisible,
        "v2-overflow-hidden": !isScrollbarVisible
      })
    }, props), {
      value: text,
      placeholder,
      ref: textAreaRef,
      rows,
      style: {
        height: (_a2 = style == null ? void 0 : style.height) != null ? _a2 : textAreaHeight
      },
      onChange: onChangeHandler
    })
  ));
}
